<template>
  <textarea
    :name="name"
    v-model="inputValue"
    class="input-textarea"
    placeholder="お悩みをこちらに入力してください。"
  ></textarea>
</template>

<script>
export default {
  name: "InputTextarea",
  props: {
    name: {
      type: String,
      default: ''
    },
    // 設定データ
    formSetting: {
      type: Object,
      default () {
        return {}
      }
    },
    // ユーザーが入力したデータ
    inputedData: {
      type: String,
      default: ''
    }
  },
  computed: {
    // データバインディングした値
    inputValue: {
      get () {
        return this.inputedData
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.input-textarea {
  width: 100%;
  min-height: 128px;
  padding: 12px 16px;
  border: 1px solid $col_temp_gray3;
  border-radius: 5px;
  font-size: 13px;
  text-align: justify;
  resize: vertical;
  background: none;
  outline: none;
  &::placeholder {
    color: $col_temp_gray3;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Favor/InputTextarea.vue